import { z } from "zod";
import type { ComponentDefinition } from "../types";

// Usage assumptions and installation facts cannot be verified by a datasheet.
export const VERIFIED_SPEC_UNITS = {
  voltage: "V", capacityAh: "Ah", watts: "W", ampDraw: "A", ampOutput: "A", ampSurge: "A",
  maxChargeA: "A", maxDischargeA: "A", pvVoc: "V", pvMaxVoc: "V",
} as const;
export const verifiedSpecSchema = z.strictObject({
  nodeId: z.string().min(1).max(100),
  field: z.enum(["chemistry", ...Object.keys(VERIFIED_SPEC_UNITS)]),
  value: z.union([z.number().finite().min(0).max(1_000_000), z.enum(["lifepo4", "agm", "lead-acid", "gel"])]),
  sourceUrl: z.string().url().max(2000), sourceTitle: z.string().min(1).max(300),
  quote: z.string().min(8).max(1000),
}).refine(item => /^https?:\/\//.test(item.sourceUrl) && (item.field === "chemistry" ? typeof item.value === "string" : typeof item.value === "number"));
export function specValueAllowed(def: ComponentDefinition, field: string, value: number | string): boolean {
  if (!def.aiEstimatedFields?.includes(field)) return false;
  if (field === "chemistry") return def.category === "battery" && ["lifepo4", "agm", "lead-acid", "gel"].includes(String(value));
  if (!(field in VERIFIED_SPEC_UNITS) || typeof value !== "number" || !Number.isFinite(value) || value < 0) return false;
  if (field === "voltage" || field === "pvVoc" || field === "pvMaxVoc") return value > 0 && value <= 1000;
  return value <= 1_000_000;
}
